import { Link } from 'react-router-dom';

const footerLinks = {
  sports: {
    title: '热门体育',
    links: [
      { label: '足球', path: '/category/football' },
      { label: '篮球', path: '/category/basketball' },
      { label: '网球', path: '/category/tennis' },
      { label: '电子竞技', path: '/category/esports' },
      { label: '赛车', path: '/category/racing' },
      { label: '棒球', path: '/category/baseball' },
    ],
  },
  platform: {
    title: '平台信息',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
      { label: '常见问题', path: '/' },
    ],
  },
  hotTags: {
    title: '热门标签',
    tags: ['bb体育', 'bb体育官网', 'bb体育平台', 'bb体育赛事', 'bb体育直播', '英超', 'NBA', '法网', 'LPL'],
  },
};

const hotTagPaths: Record<string, string> = {
  'bb体育': '/',
  'bb体育官网': '/',
  'bb体育平台': '/',
  'bb体育赛事': '/category/football',
  'bb体育直播': '/category/football',
  '英超': '/category/football',
  'NBA': '/category/basketball',
  '法网': '/category/tennis',
  'LPL': '/category/esports',
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4 group">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                <span className="text-background-50 font-heading text-lg font-bold">bb</span>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">bb体育</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              bb体育是您值得信赖的在线体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技分析及相关服务。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{footerLinks.sports.title}</h4>
            <ul className="space-y-2.5">
              {footerLinks.sports.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{footerLinks.platform.title}</h4>
            <ul className="space-y-2.5">
              {footerLinks.platform.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{footerLinks.hotTags.title}</h4>
            <div className="flex flex-wrap gap-2">
              {footerLinks.hotTags.tags.map((tag) => (
                <Link
                  key={tag}
                  to={hotTagPaths[tag] || '/'}
                  className="px-3 py-1.5 rounded-md bg-background-800 text-background-400 text-xs hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} bb体育 版权所有 | bb体育官网 | bb体育平台
          </p>
          <p className="text-xs text-background-500">
            友情链接：<a href="#" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">体育资讯</a> · <a href="#" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">赛事直播</a> · <a href="#" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">体育竞技</a>
          </p>
        </div>
      </div>
    </footer>
  );
}